import De from "../models/braze-event.js";
import _t from "../models/identifier.js";
import {
  isArray as R,
  keys as C,
  validateValueIsFromEnum as ta,
  values as Pt,
} from "../util/code-utils.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import { User } from "../User/index.js";
import ro from "../util/browser-detector.js";
import { getErrorMessage as ai } from "../util/error-utils.js";
export const STORAGE_KEYS = {
  Ou: {
    Cu: "ab.storage.userId",
    tl: "ab.storage.deviceId",
    um: "ab.storage.sessionId",
  },
  ft: {
    Qc: "ab.test",
    tE: "ab.storage.events",
    eE: "ab.storage.attributes",
    sE: "ab.storage.attributes.anonymous_user",
    ac: "ab.storage.device",
    Dl: "ab.storage.sdk_metadata",
    Tl: "ab.storage.session_id_for_cached_metadata",
    Uu: "ab.storage.pushToken",
    rE: "ab.storage.cardImpressions",
    jc: "ab.storage.serverConfig",
    oE: "ab.storage.triggers",
    nE: "ab.storage.triggers.ts",
    dm: "ab.storage.messagingSessionStart",
    Ps: "ab.storage.cc",
    Gs: "ab.storage.ccLastFullSync",
    Hs: "ab.storage.ccLastCardUpdated",
    uc: "ab.storage.globalRateLimitCurrentTokenCount",
    fc: "ab.storage.dynamicRateLimitCurrentTokenCount",
    Jt: "ab.storage.ccClicks",
    Vt: "ab.storage.ccImpressions",
    Pt: "ab.storage.ccDismissals",
    aE: "ab.storage.lastDisplayedTriggerTimesById",
    iE: "ab.storage.lastDisplayedTriggerTime",
    EE: "ab.storage.triggerFireInstancesById",
    xh: "ab.storage.signature",
    SE: "ab.storage.brazeSyncRetryCount",
    Qs: "ab.storage.sdkVersion",
    lo: "ab.storage.ff",
    vo: "ab.storage.ffImpressions",
    Do: "ab.storage.ffLastRefreshAt",
    Co: "ab.storage.ff.sessionId",
    lE: "ab.storage.lastReqToEndpoint",
    _E: "ab.storage.requestAttempts",
    Wn: "ab.storage.deferredIam",
    Jl: "ab.storage.lastSdkReq",
    uE: "ab.storage.alias",
    vt: "ab.storage.banners",
    Dt: "ab.storage.banners.impressions",
    Bt: "ab.storage.banners.sessionId",
    Ue: "ab.storage.dust.mite",
    Ne: "ab.storage.dust.host",
    Te: "ab.storage.dust.auth",
    ze: "ab.storage.dust.expiration",
  },
  pe: "ab.optOut",
};
export default class ee {
  constructor(t, e) {
    (this.TE = t), (this.cE = e), (this.TE = t), (this.cE = e);
  }
  Sl(t) {
    const e = C(STORAGE_KEYS.Ou),
      s = new ee.le(t);
    for (const t of e) s.remove(STORAGE_KEYS.Ou[t]);
  }
  Iu(t, e) {
    let s = null;
    null != e && e instanceof _t && (s = e.gt()), this.TE.store(t, s);
  }
  hE(t) {
    const e = this.$u(t);
    null != e && ((e.gm = new Date().valueOf()), this.Iu(t, e));
  }
  $u(t) {
    const e = this.TE.jr(t),
      s = ((t) => {
        let e;
        try {
          e = JSON.parse(t);
        } catch (t) {
          e = null;
        }
        return e;
      })(e);
    let r;
    if (s) (r = _t._u(s) || null), r && this.Iu(t, r);
    else {
      const s = _t.AE(e);
      (r = _t._u(s) || null), s !== e && r && this.Iu(t, r);
    }
    return r;
  }
  xm(t) {
    this.TE.remove(t);
  }
  Al() {
    const t = C(STORAGE_KEYS.Ou);
    let e;
    for (const s of t)
      (e = this.$u(STORAGE_KEYS.Ou[s])),
        null != e && this.Iu(STORAGE_KEYS.Ou[s], e);
  }
  ol(t) {
    let e;
    if (null == t || 0 === t.length) return !1;
    e = R(t) ? t : [t];
    let s = this.cE.jr(STORAGE_KEYS.ft.tE);
    (null != s && R(s)) || (s = []);
    for (let t = 0; t < e.length; t++) s.push(e[t].gt());
    return this.cE.store(STORAGE_KEYS.ft.tE, s);
  }
  wm(t) {
    return null != t && this.ol([t]);
  }
  RE() {
    let t = this.cE.jr(STORAGE_KEYS.ft.tE);
    this.cE.remove(STORAGE_KEYS.ft.tE), null == t && (t = []);
    const e = [];
    let s = !1,
      r = null;
    if (R(t))
      for (let s = 0; s < t.length; s++)
        De.gE(t[s]) ? e.push(De._u(t[s])) : (r = s);
    else s = !0;
    if (s || null != r) {
      let o = "Stored events could not be deserialized as Events";
      s &&
        (o += ", was " + Object.prototype.toString.call(t) + " not an array"),
        null != r &&
          (o += ", value at index " + r + " does not look like an event"),
        (o +=
          ", serialized values were of type " +
          typeof t +
          ": " +
          JSON.stringify(t)),
        e.push(new De(null, f.wl, new Date().valueOf(), null, { e: o }));
    }
    return e;
  }
  bt(t, e) {
    return (
      !!ta(
        STORAGE_KEYS.ft,
        t,
        "StorageManager cannot store object.",
        "STORAGE_KEYS.OBJECTS",
      ) && this.cE.store(t, e)
    );
  }
  dt(t) {
    return (
      !!ta(
        STORAGE_KEYS.ft,
        t,
        "StorageManager cannot retrieve object.",
        "STORAGE_KEYS.OBJECTS",
      ) && this.cE.jr(t)
    );
  }
  zt(t) {
    return (
      !!ta(
        STORAGE_KEYS.ft,
        t,
        "StorageManager cannot remove object.",
        "STORAGE_KEYS.OBJECTS",
      ) && (this.cE.remove(t), !0)
    );
  }
  clearData() {
    const t = C(STORAGE_KEYS.Ou),
      e = C(STORAGE_KEYS.ft);
    for (let e = 0; e < t.length; e++) {
      const s = t[e];
      this.TE.remove(STORAGE_KEYS.Ou[s]);
    }
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      this.cE.remove(STORAGE_KEYS.ft[s]);
    }
  }
  OE(t) {
    return t || STORAGE_KEYS.ft.sE;
  }
  Xl(t) {
    let e = this.cE.jr(STORAGE_KEYS.ft.eE);
    null == e && (e = {});
    const s = this.OE(t[User.Va]),
      r = e[s];
    for (const o in t)
      o !== User.Va &&
        (null == e[s] || (r && null == r[o])) &&
        this.Eu(t[User.Va], o, t[o]);
  }
  Eu(t, e, s) {
    let r = this.cE.jr(STORAGE_KEYS.ft.eE);
    null == r && (r = {});
    const o = this.OE(t);
    let n = r[o];
    if (
      (null == n && ((n = {}), null != t && (n[User.Va] = t)), e === User.Bu)
    ) {
      null == n[e] && (n[e] = {});
      for (const t in s) n[e][t] = s[t];
    } else n[e] = s;
    return (r[o] = n), this.cE.store(STORAGE_KEYS.ft.eE, r);
  }
  IE() {
    const t = this.cE.jr(STORAGE_KEYS.ft.eE);
    this.cE.remove(STORAGE_KEYS.ft.eE);
    const e = [];
    for (const s in t) null != t[s] && e.push(t[s]);
    return e;
  }
  Lu(t) {
    const e = this.cE.jr(STORAGE_KEYS.ft.eE);
    if (null != e) {
      const s = this.OE(null),
        r = e[s];
      null != r &&
        ((e[s] = void 0),
        this.cE.store(STORAGE_KEYS.ft.eE, e),
        (r[User.Va] = t),
        this.Xl(r));
    }
    const s = this.$u(STORAGE_KEYS.Ou.um);
    let r = null;
    null != s && (r = s.Tu);
    const o = this.RE();
    if (null != o)
      for (let e = 0; e < o.length; e++) {
        const s = o[e];
        null == s.userId && s.sessionId == r && (s.userId = t), this.wm(s);
      }
  }
  dE() {
    return this.cE.bE;
  }
}
(ee.Wc = class {
  constructor(t) {
    (this.tu = t), (this.tu = t), (this.bE = ro.fE() ? 3 : 10);
  }
  mE(t) {
    return t + "." + this.tu;
  }
  store(t, e) {
    const s = { v: e };
    try {
      return localStorage.setItem(this.mE(t), JSON.stringify(s)), !0;
    } catch (t) {
      return E.info("Storage failure: " + ai(t)), !1;
    }
  }
  jr(t) {
    try {
      let e = null;
      const s = localStorage.getItem(this.mE(t));
      return null != s && (e = JSON.parse(s)), null == e ? null : e.v;
    } catch (t) {
      return E.info("Storage retrieval failure: " + ai(t)), null;
    }
  }
  remove(t) {
    try {
      localStorage.removeItem(this.mE(t));
    } catch (t) {
      return E.info("Storage removal failure: " + ai(t)), !1;
    }
  }
}),
  (ee.Xc = class {
    constructor() {
      (this.KE = {}), (this.YE = 5242880), (this.bE = 3);
    }
    store(t, e) {
      const s = { value: e },
        r = this.NE(e);
      return r > this.YE
        ? (E.info(
            "Storage failure: object is ≈" +
              r +
              " bytes which is greater than the max of " +
              this.YE,
          ),
          !1)
        : ((this.KE[t] = s), !0);
    }
    NE(t) {
      const e = [],
        s = [t];
      let r = 0;
      for (; s.length; ) {
        const t = s.pop();
        if ("boolean" == typeof t) r += 4;
        else if ("string" == typeof t) r += 2 * t.length;
        else if ("number" == typeof t) r += 8;
        else if ("object" == typeof t && -1 === e.indexOf(t)) {
          let r, o;
          e.push(t);
          for (const e in t) (o = t), (r = e), s.push(o[r]);
        }
      }
      return r;
    }
    jr(t) {
      const e = this.KE[t];
      return null == e ? null : e.value;
    }
    remove(t) {
      this.KE[t] = null;
    }
  }),
  (ee.le = class {
    constructor(t, e) {
      (this.tu = t),
        (this.DE = e),
        (this.tu = t),
        (this.GE = this.CE()),
        (this.ME = 576e3),
        (this.DE = !!e);
    }
    mE(t) {
      return null != this.tu ? t + "." + this.tu : t;
    }
    CE() {
      let t = 0,
        e = document.location.hostname;
      const s = e.split("."),
        r = "ab._gd";
      for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r); )
        t++,
          (e = "." + s.slice(-1 - t).join(".")),
          (document.cookie = r + "=" + r + ";domain=" + e + ";");
      return (
        (document.cookie =
          r + "=;expires=" + new Date(0).toUTCString() + ";domain=" + e + ";"),
        e
      );
    }
    me() {
      const t = new Date();
      return t.setTime(t.getTime() + 60 * this.ME * 1e3), t.getFullYear();
    }
    pE() {
      const t = Pt(STORAGE_KEYS.Ou),
        e = document.cookie.split(";");
      for (let s = 0; s < e.length; s++) {
        let r = e[s];
        for (; " " === r.charAt(0); ) r = r.substring(1);
        let o = !1;
        for (let e = 0; e < t.length; e++)
          if (0 === r.indexOf(t[e])) {
            o = !0;
            break;
          }
        if (o) {
          const t = r.split("=")[0];
          -1 === t.indexOf("." + this.tu) && this.UE(t);
        }
      }
    }
    store(t, e) {
      this.pE();
      const s = new Date();
      s.setTime(s.getTime() + 60 * this.ME * 1e3);
      const r = "expires=" + s.toUTCString(),
        o = "domain=" + this.GE;
      let n;
      n = this.DE ? e : encodeURIComponent(e);
      const a = this.mE(t) + "=" + n + ";" + r + ";" + o + ";path=/";
      return a.length >= 4093
        ? (E.info(
            "Storage failure: string is " +
              a.length +
              " chars which is too large to store as a cookie.",
          ),
          !1)
        : ((document.cookie = a), !0);
    }
    jr(t) {
      const e = [],
        s = this.mE(t) + "=",
        r = document.cookie.split(";");
      for (let o = 0; o < r.length; o++) {
        let n = r[o];
        for (; " " === n.charAt(0); ) n = n.substring(1);
        if (0 === n.indexOf(s))
          try {
            let t;
            (t = this.DE
              ? n.substring(s.length, n.length)
              : decodeURIComponent(n.substring(s.length, n.length))),
              e.push(t);
          } catch (e) {
            return (
              E.info("Storage retrieval failure: " + ai(e)),
              this.remove(t),
              null
            );
          }
      }
      return e.length > 0 ? e[e.length - 1] : null;
    }
    remove(t) {
      this.UE(this.mE(t));
    }
    UE(t) {
      const e = t + "=;expires=" + new Date(0).toUTCString();
      (document.cookie = e), (document.cookie = e + ";path=/");
      const s = e + ";domain=" + this.GE;
      (document.cookie = s), (document.cookie = s + ";path=/");
    }
  }),
  (ee.Jc = class {
    constructor(t, e, s) {
      (this.tu = t),
        (this.vE = []),
        e && this.vE.push(new ee.le(t)),
        s && this.vE.push(new ee.Wc(t)),
        this.vE.push(new ee.Xc());
    }
    store(t, e) {
      let s = !0;
      for (let r = 0; r < this.vE.length; r++) s = this.vE[r].store(t, e) && s;
      return s;
    }
    jr(t) {
      for (let e = 0; e < this.vE.length; e++) {
        const s = this.vE[e].jr(t);
        if (null != s) return s;
      }
      return null;
    }
    remove(t) {
      new ee.le(this.tu).remove(t);
      for (let e = 0; e < this.vE.length; e++) this.vE[e].remove(t);
    }
  });
